import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { from, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from './auth';
import { Auth } from '@angular/fire/auth';
import { environment } from '../../../environments/environment';

export const partnerAppGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const authService          = inject(AuthService);
    const partnerLoginUrl      = environment.production
        ? 'https://cliente.innovate-gua.com/login'
        : 'https://socio-dev.innovate-gua.com/login';
    const adminPlatformLogin   = environment.production
        ? 'https://sige.innovate-gua.com/login'
        : 'https://sige-dev.innovate-gua.com/login';
    const firebaseAuthInstance = authService.authInstance as Auth;
    const currentUser          = firebaseAuthInstance.currentUser;

    if(!currentUser) {
        return true;
    }

    return from(currentUser.getIdTokenResult()).pipe(
        map(idTokenResult => {
            const roles: string[] = (idTokenResult.claims && Array.isArray(idTokenResult.claims['roles'])) ? idTokenResult.claims['roles'] as string[] : [];

            if(roles.includes('partner')) {
                return true;
            }

            window.location.href = adminPlatformLogin;

            return false;
        }), catchError((error) => {
            console.error('Error al obtener el token ID del usuario en partnerAppGuard:', error);

            window.location.href = partnerLoginUrl;

            return of(false);
        })
    );
};
